import { Role, TenantUser, User } from '@cco/model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const auth2Actions = createActionGroup({
  source: 'Auth2',
  events: {
    authNullAction: emptyProps(),
    authenticateUser: emptyProps(),
    authenticateUserFailure: props<{ error: any }>(),
    authenticateUserSuccess: emptyProps(),
    beginOAuth2LoginProcess: props<{ tenantCode: string; rememberMe: boolean }>(),
    beginOAuth2LoginProcessFailure: props<{ error: any }>(),
    beginOAuth2LoginProcessSuccess: emptyProps(),
    checkAuthenticationStatusFailure: props<{ error: any }>(),
    checkAuthenticationStatusSuccess: props<{ currentUser: User; redirectUrl: string }>(),
    checkAuthenticationStatusTimeout: props<{ redirectUrl?: string }>(),
    getCurrentTenantUserSuccess: props<{ tenantUser: TenantUser }>(),
    getCurrentTenantUserFailure: props<{ err: any }>(),
    listCurrentUserRolesSuccess: props<{ roles: Role[] }>(),
    listCurrentUserRolesFailure: props<{ err: any }>(),
    logout: emptyProps(),
    pingAuthenticationStatus: emptyProps(),
    pingAuthenticationStatusSuccess: props<{ currentUser: User }>(),
    remoteLogout: emptyProps(),
  },
});
